import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import useSessionEntity from './useSessionEntity';

export const useABTest = () => {
  const session = useSelector((state) => state.sessions.get('session'));
  const company = useSessionEntity('company');
  const testGroup = session?.get('test_group');

  const isExcludedMode = (excludedModes) => {
    return excludedModes.includes(session.mode);
  };

  const isInTestGroup = (testType, cohort, excludedModes = []) => {
    if (isExcludedMode(excludedModes)) return false;

    return (
      testGroup?.get('type') === testType && testGroup?.get('cohort') === cohort
    );
  };

  const isInCompanyCohort = (type, cohort, excludedModes = []) => {
    if (isExcludedMode(excludedModes)) return false;

    return company?.active_cohorts_by_type?.get(type) === cohort;
  };

  return {
    isInTestGroup,
    isInCompanyCohort,
    testGroup,
  };
};

export const usePricingTermsReverseSortTest = () => {
  const { isInCompanyCohort } = useABTest();
  const { pathname } = useLocation();

  const isOnTermsPage = pathname.startsWith('/purchase/terms');

  const type = 'terms_reverse_sort_ab';
  const cohort = 'reverse_sort';
  const isInReverseSortCohort = isInCompanyCohort(type, cohort);

  return {
    inTermsReverseSortCohort: isInReverseSortCohort && isOnTermsPage,
  };
};

export const usePricingSliderTest = () => {
  const { isInCompanyCohort } = useABTest();
  const { pathname } = useLocation();

  const isOnTermsPage = pathname.startsWith('/purchase/terms');

  const type = 'pricing_test_slider';
  const testCohort = 'pricing_test_slider_test1';
  const isInSliderTestCohort = isInCompanyCohort(type, testCohort);

  return {
    inSliderTestCohort: isInSliderTestCohort && isOnTermsPage,
  };
};
